import { ExclamationMarkIcon } from '@weblite/icons'
import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'
import { IS_IOS } from '$func/environmentInfo'
import { CompatibilityWarningLayout } from '$common/compatibility-warning-layout'
import { t } from '$i18n'

export function BrowserNotSupported({ isOpen }: { isOpen: boolean }) {
  return (
    <CompatibilityWarningLayout
      isOpen={isOpen}
      icon={
        <ExclamationMarkIcon
          sx={{ width: '64px', height: '64px', color: 'error.main' }}
        />
      }
      title={t('warningPages.browserNotSupported.title')}
      description={
        <DescriptionGroup>
          <Typography textAlign="center" component="p" variant="paragraph1">
            {t(
              `warningPages.browserNotSupported.${IS_IOS ? 'useSafari' : 'useChrome'}.text1`,
            )}
            <BrowserLogo
              src={
                IS_IOS
                  ? 'assets/icons/safari-logo.svg'
                  : 'assets/icons/chrome-logo.svg'
              }
            />
            {t(
              `warningPages.browserNotSupported.${IS_IOS ? 'useSafari' : 'useChrome'}.text2`,
            )}
          </Typography>
        </DescriptionGroup>
      }
      badge={null}
    />
  )
}

const BrowserLogo = styled('img')`
  width: 24px;
  margin: 0 6px -6px 6px;
`

const DescriptionGroup = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
`
